(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["whatsapp-sticky-button"] && !Shopify.designMode) return;
  try {
    
(() => {
  // Only enable on mobile devices
  const isMobile = window.matchMedia('(max-width: 768px)').matches;
  if (!isMobile) return;

  const fab = document.getElementById('sticky-chat-widget');
  const footer = document.getElementById('section-footer');
  const EXTRA = 60; // lift height (75px - 15px)
  let ticking = false;

  function update() {
    const r = footer.getBoundingClientRect();
    const vh = window.innerHeight;
    const overlapPx = Math.max(0, vh - Math.max(r.top, 0));
    const progress = Math.min(overlapPx / Math.max(r.height, 1), 1);
    const offset = progress * EXTRA;
    fab.style.transform = `translateY(${-offset}px)`;
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => {
      update();
      ticking = false;
    });
  }

  const io = new IntersectionObserver(
    (entries) => {
      if (entries[0].isIntersecting) {
        window.addEventListener('scroll', onScroll, { passive: true });
        window.addEventListener('resize', onScroll);
        onScroll();
      } else {
        window.removeEventListener('scroll', onScroll);
        window.removeEventListener('resize', onScroll);
        fab.style.transform = 'translateY(0)';
      }
    },
    { root: null, threshold: 0, rootMargin: '0px 0px 150px 0px' }
  );

  io.observe(footer);
})();


  } catch(e) { console.error(e); }
})();
})();
